// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3jv3U","subheader":"ReorderModal_subheader__26Rm2","listWrap":"ReorderModal_listWrap__uAPKS"};